<template>
  <div
    :class="`lf-chip flex items-center rounded-full px-2 py-1 whitespace-nowrap bg-${color}-100/50 text-right text-xs font-semibold text-${color}-500 ${uppercase && 'uppercase'} `"
  >
    <icon-base class="mr-2" :icon="icon" height="16" width="16" />
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

import IconFailure from "@/components/icons/IconFailure.vue";
import IconSuccessRoundBig from "@/components/icons/IconSuccessRoundBig.vue";
import IconWarning from "@/components/icons/IconWarning.vue";

const TYPE_COLORS = {
  success: "green",
  warning: "yellow",
  failure: "red",
};

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (type) => ["success", "warning", "failure"].includes(type),
  },
  uppercase: {
    type: Boolean,
    default: false,
  },
});
const color = computed(() => TYPE_COLORS[props.type]);
const icon = computed(() => {
  if (props.type === "success") {
    return IconSuccessRoundBig;
  }
  if (props.type === "warning") {
    return IconWarning;
  }

  return IconFailure;
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.lf-chip {
  height: max-content;
}
.lf-chip svg {
  margin-bottom: 0; /* undo -2px margin from IconBase */
}
</style>
